export default __webpack_public_path__ + "static/30-d27decd663a74fdc4110fd9017367527.png";